const listEvents = {},
    observers = []
let lib = {};
module.exports = lib = {

    /**
     * Bind actions that will be executed when 'eventName' is sent
     *
     * @param {String} eventName
     * @param {Function} cb
     */
    on: function(eventName, cb) {
        if (!listEvents[eventName])
            listEvents[eventName] = []
        listEvents[eventName].push(cb)
    },

    /**
     * Unbind 'cb' action for 'eventName'
     *
     * @param {String} eventName
     * @param {Function} cb
     */
    off: function(eventName, cb) {
        if (listEvents[eventName] && ~listEvents[eventName].indexOf(cb))
            listEvents[eventName].splice(listEvents[eventName].indexOf(cb), 1)
    },

    /**
     * Listen to element specific attributes mutation
     * 
     * @param {Object} options 
     * @param {Function} actionFunction 
     * @param {Function} observerUnbind 
     */
    mutation: function(options, eventName, actionFunction) {
        const { elt, observerOptions } = options;
        const observer = new MutationObserver(() => {
            actionFunction();
        })
        observer.observe(elt, observerOptions);
        observers.push({
            event: eventName,
            observer: observer
        })
    },

    /**
     * Remove previously created mutation observer
     * 
     * @param {String} event 
     */
    removeMutationObserver(event) {
        const observerToRemove = observers.find(obs => obs.event === event);
        if (observerToRemove !== undefined) {
            observerToRemove.observer.disconnect();
        }
    },


    /**
     * Send 'eventName' event with parameters
     *
     * @param {any} eventName
     * @param {any} args
     */
    send: function(eventName, args) {
        if (listEvents[eventName])
            listEvents[eventName].map(function(f) { f(args) })
    }

}

/**
* INIT BASIC CUBE-EVENTS
*/
var winWidth = window.innerWidth,
    winHeight = window.innerHeight;

window.onresize = function(event) {

    var newWidth = window.innerWidth,
        newHeight = window.innerHeight;

    if (winWidth !== newWidth) {
        winWidth = newWidth;
        lib.send('resize-width', event);
    }
    if (winHeight !== newHeight) {
        winHeight = newHeight;
        lib.send('resize-height', event);
    }

    lib.send('resize', event);
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-event.js